<template>
    <div>
        <div id="otpModal" class="modal fade" ref="exampleModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="row" v-if="isLoading && isCloseable">
                        <div v-if="isCloseable" class="modal-header">
                            <button type="button" class="btn-close" @click="hideModal"></button>
                        </div>
                        <div class="modal-body">
                            <div class="col-12 text-center">
                                <Spinner />
                                <p>{{ $t('views.auth.otp.sending_code') }}</p>
                            </div>
                        </div>
                    </div>
                    <template v-else>
                        <div class="modal-header">
                            <h2 class="modal-title" id="accountAddCardModalLabel" style="font-weight: 500 !important; margin: 0 !important">{{ $t('actions.verify') }}</h2>
                            <button v-if="isCloseable" type="button" class="btn-close" @click="hideModal"></button>
                        </div>
                        <div class="modal-body">
                            <div v-if="!isCloseable" class="d-flex flex-column gap-2 mb-4">
                                <span>{{ $t('views.auth.otp.select_package') }}</span>
                                <span v-if="user">{{ $t('views.auth.otp.verify_code_sms', { forwardTo: formatPhoneNumber(user.mobileNo) }) }}</span>
                            </div>
                            <template v-else>
                                <div class="mb-4" v-if="type === 'sms' && forwardTo">
                                    <p>{{ $t('views.auth.otp.verify_code_sms', { forwardTo }) }}</p>
                                </div>
                                <div class="mb-4" v-if="type === 'email' && forwardTo">
                                    <p>{{ $t('views.auth.otp.verify_code_email', { forwardTo }) }}</p>
                                </div>
                            </template>
                            <div class="mb-4 position-relative">
                                <label for="cardNameLabel" class="form-label">{{ $t('views.auth.otp.verify_code') }}</label>
                                <input v-model="code" type="text" class="form-control" id="cardNameLabel" placeholder="" />
                                <span class="position-absolute" style="top: 40px; right: 15px"> {{ expirationFormatted }} </span>
                            </div>
                            <div class="d-flex justify-content-end gap-3">
                                <button v-if="isCloseable" type="button" class="btn btn-white" @click="hideModal">{{ $t('actions.cancel') }}</button>
                                <button v-else type="button" class="btn btn-white" :disabled="expiration > 0" @click="sendOtp">{{ $t('actions.resend') }}</button>
                                <button type="button" class="btn btn-primary" :disabled="isSubmitButtonDisabled" @click="handleSubmit">
                                    <Spinner v-if="form_submitted" />
                                    <span v-if="!form_submitted">{{ $t('actions.verify') }}</span>
                                </button>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Modal } from 'bootstrap'
import AuthService from '@/services/auth'
import Spinner from '../Spinner.vue'

export default {
    name: 'SupportFormModal',
    components: { Spinner },
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({}),
        },
        type: {
            type: String,
            default: 'sms',
        },
        isCloseable: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        form_submitted: false,
        modalInstance: null,
        form_id: Math.round(Math.random() * 1000),
        code: null,
        isLoading: true,
        forwardTo: null,
        expiration: 120,
        expirationFormatted: '',
        interval: null,
    }),
    computed: {
        ...mapGetters('auth', ['user']),
        isSubmitButtonDisabled() {
            if (!this.code) {
                return true
            }
            return this.code.length !== 6 || this.expiration === 0
        },
    },
    watch: {
        showModal(newValue, oldValue) {
            if (newValue === true) {
                this.form_submitted = false
                this.modalActive()
                const currentTime = new Date().getTime()
                const lastRequestTime = localStorage.getItem('lastRequestTimePhone')

                if (lastRequestTime) {
                    const timeDifference = currentTime - parseInt(lastRequestTime, 10)
                    const twoMinutes = 2 * 60 * 1000

                    if (timeDifference < twoMinutes) {
                        this.expiration = Math.ceil((twoMinutes - timeDifference) / 1000)
                        this.interval = setInterval(() => {
                            if (this.expiration > 0) {
                                this.expiration--
                            } else {
                                clearInterval(this.interval)
                            }
                        }, 1000)
                        return
                    }
                }
                this.sendOtp()
                this.expiration = 120
                this.code = null
                this.forwardTo = null
                localStorage.setItem('lastRequestTimePhone', currentTime.toString())
            }
        },
        expiration: {
            handler: function (val) {
                if (+val === 0) {
                    if (this.isCloseable) {
                        this.hideModal()
                    }
                }
                const minute = Math.floor(+val / 60)
                const second = val % 60
                this.expirationFormatted = `${minute < 10 ? '0' + minute : minute}:${second < 10 ? '0' + second : second}`
            },
            immediate: true,
        },
    },
    methods: {
        async sendOtp() {
            const currentTime = new Date().getTime()
            const lastRequestTime = localStorage.getItem('lastRequestTimePhone')

            if (lastRequestTime) {
                const timeDifference = currentTime - parseInt(lastRequestTime, 10)
                const twoMinutes = 2 * 60 * 1000

                if (timeDifference < twoMinutes) {
                    this.expiration = Math.ceil((twoMinutes - timeDifference) / 1000)
                    this.interval = setInterval(() => {
                        if (this.expiration > 0) {
                            this.expiration--
                        } else {
                            clearInterval(this.interval)
                        }
                    }, 1000)
                    return
                }
            }

            this.expiration = 120
            this.isLoading = true
            if (this.type === 'sms') {
                AuthService.sendOtp(this.data)
                    .then((response) => {
                        this.isLoading = false
                        this.forwardTo = response.data.masked_phone
                        this.interval = setInterval(() => {
                            if (this.expiration > 0) {
                                this.expiration--
                            } else {
                                clearInterval(this.interval)
                            }
                        }, 1000)
                    })
                    .catch((error) => {
                        this.$toast.error(error.response.data.message)
                        this.isLoading = false
                    })
            } else if (this.type === 'email') {
                AuthService.sendEmail(this.data)
                    .then((response) => {
                        this.isLoading = false
                    })
                    .catch((error) => {
                        this.$toast.error(error.response.data.message)
                        this.isLoading = false
                    })
            }
            localStorage.setItem('lastRequestTimePhone', currentTime.toString())
        },
        async handleSubmit() {
            if (!this.code || (this.code && this.code.length !== 6)) {
                this.$toast.error(this.$t('views.auth.otp.invalid_code'))
                this.isLoading = false
                return
            }
            this.form_submitted = true
            if (this.type === 'sms') {
                AuthService.verifyOtp({
                    ...this.data,
                    code: this.code,
                    remember_me: false,
                    login: false,
                })
                    .then((response) => {
                        if (!response.data.verified) {
                            this.$toast.error(this.$t('views.auth.otp.invalid_code'))
                        } else {
                            this.$emit('handleSubmit', response)
                            this.form_submitted = true
                            this.hideModal()
                        }
                    })
                    .catch((error) => {
                        this.$toast.error(error.response.data.message)
                    })
                    .finally(() => {
                        this.form_submitted = false
                    })
            }
        },
        modalActive: function () {
            this.modalInstance = new Modal(document.getElementById('otpModal'), {
                target: '#my-modal',
                backdrop: 'static',
                keyboard: false,
            })
            this.modalInstance.show()
        },
        hideModal: function () {
            this.modalInstance.hide()
            if (this.interval) clearInterval(this.interval)
            this.code = null
            this.$emit('closeModal')
        },
        formatPhoneNumber(number) {
            const str = number.toString()
            return `${str.slice(0, 3)}****${str.slice(-2)}`
        },
    },
}
</script>

<style scoped></style>
